(() => {
  const ROOT_DETAILS_SELECTOR = '.animal-sapiens-mobile-item > details';
  const OFFERS_SELECTOR = '[data-mobile-offers-carousel]';

  const shuffle = (items) => {
    const shuffled = [...items];
    for (let index = shuffled.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [shuffled[index], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[index]];
    }
    return shuffled;
  };

  const initializeRootAccordions = (scope = document) => {
    const detailsElements = Array.from(scope.querySelectorAll?.(ROOT_DETAILS_SELECTOR) || []);

    detailsElements.forEach((details) => {
      if (details.dataset.asMobileAccordionReady === 'true') return;
      details.dataset.asMobileAccordionReady = 'true';

      details.addEventListener('toggle', () => {
        if (!details.open) return;

        detailsElements.forEach((sibling) => {
          if (sibling !== details && sibling.open) sibling.open = false;
        });
      });
    });
  };

  const initializeOffers = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.mobileOffersReady === 'true') return;

    const viewport = root.querySelector('[data-mobile-offers-viewport]');
    const track = root.querySelector('[data-mobile-offers-track]');
    const previous = root.querySelector('[data-mobile-offers-prev]');
    const next = root.querySelector('[data-mobile-offers-next]');
    const cards = Array.from(root.querySelectorAll('[data-mobile-offer-card]'));

    if (!viewport || !track || cards.length === 0) return;
    root.dataset.mobileOffersReady = 'true';

    cards.forEach((card) => {
      card.classList.remove('is-selected');
      card.setAttribute('aria-hidden', 'true');
    });

    shuffle(cards)
      .slice(0, Math.min(8, cards.length))
      .forEach((card) => {
        card.classList.add('is-selected');
        card.setAttribute('aria-hidden', 'false');
        track.appendChild(card);
      });

    const updateControls = () => {
      const atStart = viewport.scrollLeft <= 4;
      const atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 4;
      if (previous) previous.disabled = atStart;
      if (next) next.disabled = atEnd;
    };

    const scrollAmount = () => {
      const card = track.querySelector('.is-selected');
      return card ? card.getBoundingClientRect().width + 12 : viewport.clientWidth * 0.72;
    };

    previous?.addEventListener('click', () => viewport.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    next?.addEventListener('click', () => viewport.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
    viewport.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    requestAnimationFrame(updateControls);
  };

  const scan = (scope = document) => {
    initializeRootAccordions(scope);

    if (scope instanceof HTMLElement && scope.matches(OFFERS_SELECTOR)) initializeOffers(scope);
    scope.querySelectorAll?.(OFFERS_SELECTOR).forEach(initializeOffers);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else {
    scan();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) scan(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

(() => {
  if (window.__animalSapiensEducationMenuV7) return;
  window.__animalSapiensEducationMenuV7 = true;

  const TEXT_SELECTOR = [
    '.animal-sapiens-menu-v2 .text',
    '.animal-sapiens-menu-v2 .professional-mega-v3__quick-link',
    '.animal-sapiens-menu-v2 .professional-mega-v3__category-link > span:first-child',
    '.animal-sapiens-menu-v2 .professional-mega-v3__sublink > span:first-child',
    '.animal-sapiens-mobile-menu .text'
  ].join(',');

  const isCatalan = (document.documentElement.lang || '').toLowerCase().startsWith('ca');
  const replacements = isCatalan
    ? {
        Adiestramiento: 'Educació',
        Ensinistrament: 'Educació',
        Educación: 'Educació',
        'Collares educativos': 'Collars educatius',
        "Collars d'ensinistrament": 'Collars educatius',
        'Arneses educativos': 'Arnesos educatius',
        "Arnesos d'ensinistrament": 'Arnesos educatius'
      }
    : {
        Adiestramiento: 'Educación',
        Ensinistrament: 'Educación'
      };

  const normalizeElement = (element) => {
    if (!(element instanceof HTMLElement)) return;
    const rawText = element.textContent || '';
    const normalizedText = rawText.trim();
    const replacement = replacements[normalizedText];
    if (!replacement || replacement === normalizedText) return;
    element.textContent = rawText.replace(normalizedText, replacement);
  };

  const scanMenuLabels = (scope = document) => {
    if (scope instanceof HTMLElement && scope.matches(TEXT_SELECTOR)) normalizeElement(scope);
    scope.querySelectorAll?.(TEXT_SELECTOR).forEach(normalizeElement);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scanMenuLabels(), { once: true });
  } else {
    scanMenuLabels();
  }

  document.addEventListener('shopify:section:load', (event) => scanMenuLabels(event.target));

  const labelObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) scanMenuLabels(node);
      });
    });
  });

  labelObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
